// // // import { useState } from "react";
// // // import { Search, SlidersHorizontal, LayoutGrid, List } from "lucide-react";
// // // import ProjectCard from "../components/modules/projects/ProjectCard";
// // // import projectsData from "../data/projectsData";

// // // const filters = ["All", "In Production", "Inspection", "Awaiting Approval", "Review", "Delivered"];
// // // const centreCount = new Set(projectsData.map((p) => p.centre)).size;

// // // export default function MyProjects() {
// // //   const [query, setQuery] = useState("");
// // //   const [activeFilter, setActiveFilter] = useState("All");
// // //   const [view, setView] = useState("grid");

// // //   const filtered = projectsData.filter((p) => {
// // //     const matchesFilter = activeFilter === "All" || p.status === activeFilter;
// // //     const matchesQuery =
// // //       p.title.toLowerCase().includes(query.toLowerCase()) ||
// // //       p.id.toLowerCase().includes(query.toLowerCase());
// // //     return matchesFilter && matchesQuery;
// // //   });

// // //   return (
// // //     <div>
// // //       <h1 className="text-3xl font-extrabold text-gray-900">My Projects</h1>
// // //       <p className="text-gray-500 mt-1 mb-6">
// // //         {projectsData.length} prototype projects across {centreCount} APIC centres
// // //       </p>

// // //       {/* Search + filters */}
// // //       <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-6">
// // //         <div className="flex items-center gap-3 mb-4">
// // //           <div className="flex items-center gap-2 flex-1 bg-white border border-gray-300 rounded-xl px-4 py-2.5">
// // //             <Search className="w-4 h-4 text-gray-400" />
// // //             <input
// // //               value={query}
// // //               onChange={(e) => setQuery(e.target.value)}
// // //               placeholder="Search project name or ID..."
// // //               className="w-full bg-transparent text-sm focus:outline-none"
// // //             />
// // //           </div>

// // //           <button
// // //             type="button"
// // //             className="flex items-center gap-2 text-sm font-medium px-4 py-2.5 rounded-xl border border-gray-300 text-gray-700 hover:border-indigo-300 shrink-0"
// // //           >
// // //             <SlidersHorizontal className="w-4 h-4" />
// // //             Filters
// // //           </button>

// // //           <div className="flex items-center gap-1 border border-gray-300 rounded-xl p-1 shrink-0">
// // //             <button
// // //               type="button"
// // //               onClick={() => setView("grid")}
// // //               aria-label="Grid view"
// // //               className={`p-1.5 rounded-lg transition ${
// // //                 view === "grid" ? "bg-indigo-600 text-white" : "text-gray-400 hover:text-gray-600"
// // //               }`}
// // //             >
// // //               <LayoutGrid className="w-4 h-4" />
// // //             </button>
// // //             <button
// // //               type="button"
// // //               onClick={() => setView("list")}
// // //               aria-label="List view"
// // //               className={`p-1.5 rounded-lg transition ${
// // //                 view === "list" ? "bg-indigo-600 text-white" : "text-gray-400 hover:text-gray-600"
// // //               }`}
// // //             >
// // //               <List className="w-4 h-4" />
// // //             </button>
// // //           </div>
// // //         </div>

// // //         <div className="flex flex-wrap gap-2">
// // //           {filters.map((f) => {
// // //             const isActive = activeFilter === f;
// // //             return (
// // //               <button
// // //                 key={f}
// // //                 type="button"
// // //                 onClick={() => setActiveFilter(f)}
// // //                 className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
// // //                   isActive
// // //                     ? "bg-indigo-600 border-indigo-600 text-white"
// // //                     : "bg-white border-gray-300 text-gray-700 hover:border-indigo-300"
// // //                 }`}
// // //               >
// // //                 {f}
// // //               </button>
// // //             );
// // //           })}
// // //         </div>
// // //       </div>

// // //       {/* Project list */}
// // //       {filtered.length > 0 ? (
// // //         <div
// // //           className={
// // //             view === "grid"
// // //               ? "grid md:grid-cols-2 lg:grid-cols-3 gap-5"
// // //               : "space-y-4"
// // //           }
// // //         >
// // //           {filtered.map((p) => (
// // //             <ProjectCard key={p.id} project={p} />
// // //           ))}
// // //         </div>
// // //       ) : (
// // //         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
// // //           No projects match your search.
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // }




// // import { useState } from "react";
// // import { Search, SlidersHorizontal, LayoutGrid, List } from "lucide-react";
// // import ProjectCard from "../components/modules/projects/ProjectCard";
// // import ProjectListRow from "../components/modules/projects/ProjectListRow";
// // import projectsData from "../data/projectsData";

// // const filters = ["All", "In Production", "Inspection", "Awaiting Approval", "Review", "Delivered"];
// // const centreCount = new Set(projectsData.map((p) => p.centre)).size;

// // export default function MyProjects() {
// //   const [query, setQuery] = useState("");
// //   const [activeFilter, setActiveFilter] = useState("All");
// //   const [view, setView] = useState("list");

// //   const filtered = projectsData.filter((p) => {
// //     const matchesFilter = activeFilter === "All" || p.status === activeFilter;
// //     const matchesQuery =
// //       p.title.toLowerCase().includes(query.toLowerCase()) ||
// //       p.id.toLowerCase().includes(query.toLowerCase());
// //     return matchesFilter && matchesQuery;
// //   });

// //   return (
// //     <div>
// //       <h1 className="text-3xl font-extrabold text-gray-900">My Projects</h1>
// //       <p className="text-gray-500 mt-1 mb-6">
// //         {projectsData.length} prototype projects across {centreCount} APIC centres
// //       </p>

// //       {/* Search + filters */}
// //       <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-6">
// //         <div className="flex items-center gap-3 mb-4">
// //           <div className="flex items-center gap-2 flex-1 bg-white border border-gray-300 rounded-xl px-4 py-2.5">
// //             <Search className="w-4 h-4 text-gray-400" />
// //             <input
// //               value={query}
// //               onChange={(e) => setQuery(e.target.value)}
// //               placeholder="Search project name or ID..."
// //               className="w-full bg-transparent text-sm focus:outline-none"
// //             />
// //           </div>

// //           <button
// //             type="button"
// //             className="flex items-center gap-2 text-sm font-medium px-4 py-2.5 rounded-xl border border-gray-300 text-gray-700 hover:border-indigo-300 shrink-0"
// //           >
// //             <SlidersHorizontal className="w-4 h-4" />
// //             Filters
// //           </button>

// //           <div className="flex items-center gap-1 border border-gray-300 rounded-xl p-1 shrink-0">
// //             <button
// //               type="button"
// //               onClick={() => setView("grid")}
// //               aria-label="Grid view"
// //               className={`p-1.5 rounded-lg transition ${
// //                 view === "grid" ? "bg-indigo-600 text-white" : "text-gray-400 hover:text-gray-600"
// //               }`}
// //             >
// //               <LayoutGrid className="w-4 h-4" />
// //             </button>
// //             <button
// //               type="button"
// //               onClick={() => setView("list")}
// //               aria-label="List view"
// //               className={`p-1.5 rounded-lg transition ${
// //                 view === "list" ? "bg-indigo-600 text-white" : "text-gray-400 hover:text-gray-600"
// //               }`}
// //             >
// //               <List className="w-4 h-4" />
// //             </button>
// //           </div>
// //         </div>

// //         <div className="flex flex-wrap gap-2">
// //           {filters.map((f) => {
// //             const isActive = activeFilter === f;
// //             return (
// //               <button
// //                 key={f}
// //                 type="button"
// //                 onClick={() => setActiveFilter(f)}
// //                 className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
// //                   isActive
// //                     ? "bg-indigo-600 border-indigo-600 text-white"
// //                     : "bg-white border-gray-300 text-gray-700 hover:border-indigo-300"
// //                 }`}
// //               >
// //                 {f}
// //               </button>
// //             );
// //           })}
// //         </div>
// //       </div>

// //       {/* Project list */}
// //       {filtered.length > 0 ? (
// //         view === "grid" ? (
// //           <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
// //             {filtered.map((p) => (
// //               <ProjectCard key={p.id} project={p} />
// //             ))}
// //           </div>
// //         ) : (
// //           <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
// //             {filtered.map((p) => (
// //               <ProjectListRow key={p.id} project={p} />
// //             ))}
// //           </div>
// //         )
// //       ) : (
// //         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
// //           No projects match your search.
// //         </div>
// //       )}
// //     </div>
// //   );
// // }



// import { useState } from "react";
// import { Search, SlidersHorizontal, LayoutGrid, List } from "lucide-react";
// import ProjectCard from "../components/modules/projects/ProjectCard";
// import ProjectListRow from "../components/modules/projects/ProjectListRow";
// import projectsData from "../data/projectsData";

// const filters = ["All", "In Production", "Inspection", "Awaiting Approval", "Review", "Delivered"];
// const centreCount = new Set(projectsData.map((p) => p.centre)).size;

// export default function MyProjects() {
//   const [query, setQuery] = useState("");
//   const [activeFilter, setActiveFilter] = useState("All");
//   const [view, setView] = useState("grid"); // ✅ Changed default to "grid"

//   const filtered = projectsData.filter((p) => {
//     const matchesFilter = activeFilter === "All" || p.status === activeFilter;
//     const matchesQuery =
//       p.title.toLowerCase().includes(query.toLowerCase()) ||
//       p.id.toLowerCase().includes(query.toLowerCase());
//     return matchesFilter && matchesQuery;
//   });

//   return (
//     <div>
//       <h1 className="text-3xl font-extrabold text-gray-900">My Projects</h1>
//       <p className="text-gray-500 mt-1 mb-6">
//         {projectsData.length} prototype projects across {centreCount} APIC centres
//       </p>

//       {/* Search + filters */}
//       <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-6" style={{justifyContent:"space-between", display:"flex"}}>
//         <div className="flex items-center gap-3">
//           <div className="flex items-center gap-2 flex-1 bg-white border border-gray-300 rounded-xl px-4 py-2.5">
//             <Search className="w-4 h-4 text-gray-400" />
//             <input
//               value={query}
//               onChange={(e) => setQuery(e.target.value)}
//               placeholder="Search project name or ID..."
//               className="w-full bg-transparent text-sm focus:outline-none"
//             />
//           </div>

//           <button
//             type="button"
//             className="flex items-center gap-2 text-sm font-medium px-4 py-2.5 rounded-xl border border-gray-300 text-gray-700 hover:border-indigo-300 shrink-0"
//           >
//             <SlidersHorizontal className="w-4 h-4" />
//             Filters
//           </button>

//           {/* ✅ View toggle - hidden on mobile, visible on tablet+ */}
//           <div className="hidden sm:flex items-center gap-1 border border-gray-300 rounded-xl p-1 shrink-0">
//             <button
//               type="button"
//               onClick={() => setView("grid")}
//               aria-label="Grid view"
//               className={`p-1.5 rounded-lg transition ${
//                 view === "grid" ? "bg-indigo-600 text-white" : "text-gray-400 hover:text-gray-600"
//               }`}
//             >
//               <LayoutGrid className="w-4 h-4" />
//             </button>
//             <button
//               type="button"
//               onClick={() => setView("list")}
//               aria-label="List view"
//               className={`p-1.5 rounded-lg transition ${
//                 view === "list" ? "bg-indigo-600 text-white" : "text-gray-400 hover:text-gray-600"
//               }`}
//             >
//               <List className="w-4 h-4" />
//             </button>
//           </div>
//         </div>

//         <div className="flex flex-wrap gap-2">
//           {filters.map((f) => {
//             const isActive = activeFilter === f;
//             return (
//               <button
//                 key={f}
//                 type="button"
//                 onClick={() => setActiveFilter(f)}
//                 className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
//                   isActive
//                     ? "bg-indigo-600 border-indigo-600 text-white"
//                     : "bg-white border-gray-300 text-gray-700 hover:border-indigo-300"
//                 }`}
//               >
//                 {f}
//               </button>
//             );
//           })}
//         </div>
//       </div>

//       {/* Project list */}
//       {filtered.length > 0 ? (
//         view === "grid" ? (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
//             {filtered.map((p) => (
//               <ProjectCard key={p.id} project={p} />
//             ))}
//           </div>
//         ) : (
//           <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
//             {filtered.map((p) => (
//               <ProjectListRow key={p.id} project={p} />
//             ))}
//           </div>
//         )
//       ) : (
//         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
//           No projects match your search.
//         </div>
//       )}
//     </div>
//   );
// }



import { useState } from "react";
import { Search, SlidersHorizontal, LayoutGrid, List, X } from "lucide-react";
import ProjectCard from "../components/modules/projects/ProjectCard";
import ProjectListRow from "../components/modules/projects/ProjectListRow";
import projectsData from "../data/projectsData";

const filters = ["All", "In Production", "Inspection", "Awaiting Approval", "Review", "Delivered"];
const centreCount = new Set(projectsData.map((p) => p.centre)).size;

export default function MyProjects() {
  const [query, setQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");
  const [view, setView] = useState("grid");
  const [showFilters, setShowFilters] = useState(false);

  const filtered = projectsData.filter((p) => {
    const matchesFilter = activeFilter === "All" || p.status === activeFilter;
    const matchesQuery =
      p.title.toLowerCase().includes(query.toLowerCase()) ||
      p.id.toLowerCase().includes(query.toLowerCase());
    return matchesFilter && matchesQuery;
  });

  const activeFilterCount = activeFilter !== "All" ? 1 : 0;

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">My Projects</h1>
      <p className="text-gray-500 mt-1 mb-6">
        {projectsData.length} prototype projects across {centreCount} APIC centres
      </p>

      {/* Search + filters */}
      <div className="bg-white border border-gray-200 rounded-2xl p-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 flex-1 bg-white border border-gray-300 rounded-xl px-4 py-2.5">
            <Search className="w-4 h-4 text-gray-400" />
            <input
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Search project name or ID..."
              className="w-full bg-transparent text-sm focus:outline-none"
            />
          </div>

          <button
            type="button"
            onClick={() => setShowFilters(!showFilters)}
            className="flex items-center gap-2 text-sm font-medium px-4 py-2.5 rounded-xl border border-gray-300 text-gray-700 hover:border-indigo-300 shrink-0 transition"
          >
            <SlidersHorizontal className="w-4 h-4" />
            Filters
            {activeFilterCount > 0 && (
              <span className="bg-indigo-600 text-white text-xs rounded-full px-2 py-0.5">
                {activeFilterCount}
              </span>
            )}
          </button>

          {/* View toggle - hidden on mobile, visible on tablet+ */}
          <div className="hidden sm:flex items-center gap-1 border border-gray-300 rounded-xl p-1 shrink-0">
            <button
              type="button"
              onClick={() => setView("grid")}
              aria-label="Grid view"
              className={`p-1.5 rounded-lg transition ${
                view === "grid" ? "bg-indigo-600 text-white" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              <LayoutGrid className="w-4 h-4" />
            </button>
            <button
              type="button"
              onClick={() => setView("list")}
              aria-label="List view"
              className={`p-1.5 rounded-lg transition ${
                view === "list" ? "bg-indigo-600 text-white" : "text-gray-400 hover:text-gray-600"
              }`}
            >
              <List className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Filter Dropdown */}
        {showFilters && (
          <div className="mt-4 pt-4 border-t border-gray-200">
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm font-semibold text-gray-700">Filter by Status</span>
              <button
                onClick={() => setShowFilters(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            <div className="flex flex-wrap gap-2">
              {filters.map((f) => {
                const isActive = activeFilter === f;
                return (
                  <button
                    key={f}
                    type="button"
                    onClick={() => {
                      setActiveFilter(f);
                      setShowFilters(false);
                    }}
                    className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
                      isActive
                        ? "bg-indigo-600 border-indigo-600 text-white"
                        : "bg-white border-gray-300 text-gray-700 hover:border-indigo-300"
                    }`}
                  >
                    {f}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Project list */}
      {filtered.length > 0 ? (
        view === "grid" ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {filtered.map((p) => (
              <ProjectCard key={p.id} project={p} />
            ))}
          </div>
        ) : (
          <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden">
            {filtered.map((p) => (
              <ProjectListRow key={p.id} project={p} />
            ))}
          </div>
        )
      ) : (
        <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
          No projects match your search.
        </div>
      )}
    </div>
  );
}